import { render, staticRenderFns } from "./cv-list.vue?vue&type=template&id=7aa504f0&"
import script from "./cv-list.vue?vue&type=script&lang=js&"
export * from "./cv-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports